/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from '../../services/modules';
import accountService from '../../services/account';

export default {
  data() {
    return {
      form: new Forms({}),
      loading: false,
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      account: 'account',
      modules: 'allModules',
    }),
  },

  mounted() {
    this.loading = true;
    const fields = {};
    let hasOptions = false;
    if (this.module.fields) {
      for (let i = 0; i < this.module.fields.length; i++) {
        const newField = {
          type: this.module.fields[i].type || 'text',
          value: '',
        };
        if (this.module.fields[i].options) {
          hasOptions = true;
        }
        fields[this.module.fields[i].name] = newField;
      }

      this.form = new Forms(fields);
      if (hasOptions) {
        for (let i = 0; i < this.module.fields.length; i++) {
          if (this.module.fields[i].options) {
            const options = this.module.fields[i].options;
            this.form.setOptions(this.module.fields[i].name, Object.keys(options).map(key => ({
              id: key,
              name: options[key],
            })));
          }
        }
      }
    }
    this.loading = false;
  },

  watch: {

  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Fetch the component's required resources.
     */
    getResources() {

    },

    subscribe() {
      this.form.loading = true;
      const obj = Object.assign({ module_id: this.module.id }, this.form.data());
      modulesService.subscribe(this.module.id, obj)
      .then(() => {
        Promise.all([
          modulesService.items(),
          accountService.find(),
        ]).then(() => {
          this.closeModal();
        });
      })
      .catch((error) => {
        const message = error.data ? error.data.message : 'Field Required';
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
        this.form.recordErrors(error);
        this.form.loading = false;
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/ehfModuleSetup/ehfModuleSetup.js